import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

/**
 * @component FullPageLoader
 * @description Muestra un loader centrado en pantalla completa con fondo translúcido.
 *
 * @param {boolean} loading - Indica si el loader debe mostrarse.
 * @param {number} [size=15] - Tamaño del spinner.
 * @param {string} [color='#0a83e6'] - Color del spinner.
 * @returns {JSX.Element|null}
 *
 * @example
 * <FullPageLoader loading={true} />
 */
const FullPageLoader = ({ loading, size = 15, color = '#0a83e6' }) => {
	if (!loading) return null;

	const override = {
		display: 'block',
		margin: '0 auto',
		borderColor: 'red'
	};

	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100vw',
				height: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				backgroundColor: 'rgba(255, 255, 255, 0.8)',
				zIndex: 9999
			}}>
			<BeatLoader
				color={color}
				loading={loading}
				size={size}
				cssOverride={override}
				aria-label="Loading..."
				data-testid="loader"/>
		</div>
	);
};

export default FullPageLoader;